// extracted by mini-css-extract-plugin
module.exports = {"allergyInfo":"allergyInfo_allergyInfo__1X1gz"};